import filter from 'lodash/filter';
import { SideBarMenu, UserProfileResponse } from 'features/login/interface/login.interface';
import { allPermissionMapping } from 'shared/constants/constants';
import localizationConstants from 'shared/util/translation/constants';

interface MenuItem {
	name: string;
	route: string;
	displayName?: string;
	children?: {
		permission?: string;
		name: string;
		url: string;
	}[];
	requiredPermission?: string;
}

const MENU_CONFIG: MenuItem[] = [
	{
		name: localizationConstants.dashboardTitle,
		route: '',
		displayName: localizationConstants.dashboardTitle
	},
	{
		name: localizationConstants.organizationsTitle,
		route: 'organizations',
		children: [
			{ permission: 'organizationsSuperAdminModule', name: localizationConstants.superAdmin, url: '/organizations/superAdmin/list' },
			{ permission: 'organizationsLicenseModule', name: localizationConstants.license, url: '/organizations/license/list' },
			{ permission: 'organizationsSupportModule', name: localizationConstants.support, url: '/organizations/support/list' },
			{ permission: 'organizationsIncomingLicenseModule', name: localizationConstants.incomingLicenseList, url: '/organizations/incoming-license' },
			{ permission: 'phoenixIncomingLicenseModule', name: localizationConstants.phoenixIncomingLicenseList, url: '/organizations/phoenix/incoming-license' },
			{ permission: 'jumpbirdIncomingLicenseModule', name: localizationConstants.jumpbirdIncomingLicenseList, url: '/organizations/jumpbird/incoming-license' }
		]
	},
	{
		name: localizationConstants.accounting,
		route: 'accounting',
		children: [
			{ permission: 'allPartnerReportList', name: localizationConstants.provision, url: '/accounting/provision/reports/list' },
			{ permission: 'phoenixSmartposListReports', name: 'Phoenix Smartpos', url: '/accounting/phoenix/smartpos' },
			{ permission: 'invoicesList', name: localizationConstants.invoices, url: '/accounting/invoices/list' },
			{ permission: 'inventories', name: localizationConstants.inventories, url: '/accounting/inventories/list' },
			{ permission: 'listInventoryGroup', name: localizationConstants.inventoryGroup, url: '/accounting/inventory-group/list' },
			{ permission: 'taxRulesListTaxRules', name: localizationConstants.taxRules, url: '/accounting/tax-rules/list' },
			{ permission: 'invoicesCustomersList', name: localizationConstants.documents, url: '/accounting/customers/list' },
			{ permission: 'reaList', name: localizationConstants.reaList, url: '/accounting/rea/list' },
			{ permission: 'turnoverStatistics', name: localizationConstants.turnoverStatistics, url: '/accounting/turnover' }
		]
	},
	{
		name: localizationConstants.posbillAdmin,
		route: 'licenses',
		children: [
			{ permission: 'licensesIncoming', name: localizationConstants.incomingLicenseList, url: '/licenses/incoming' },
			{ permission: 'licensesMachineList', name: localizationConstants.machineListTitle, url: '/licenses/machine/list' },
			{ permission: 'autoUpdateMachineList', name: localizationConstants.autoUpdateMachineTitle, url: '/licenses/auto-update-machine/list' },
			{ permission: 'licensesLicenseNumbers', name: localizationConstants.licenseNumberView, url: '/licenses/license-numbers' },
			{ permission: 'customerLicenseModuleList', name: localizationConstants.licenseModule, url: '/licenses/module/list' },
			{ permission: 'orderCodeExtensionsList', name: localizationConstants.orderCodeExtensions, url: '/licenses/order-code-extension' },
			{ permission: 'licensesConfigurationList', name: localizationConstants.configurations, url: '/licenses/configurations' }
		]
	},
	{
		name: localizationConstants.users,
		route: 'users',
		requiredPermission: 'usersModule',
		children: [
			{ permission: 'usersModule', name: localizationConstants.list, url: '/users/list' },
			{ permission: 'usersCreate', name: localizationConstants.create, url: '/users/add' }
		]
	},
	{
		name: localizationConstants.role,
		route: 'roles',
		displayName: localizationConstants.rolesAndPermissions,
		children: [
			{ permission: 'rolesModule', name: localizationConstants.roles, url: '/roles/list' },
			{ permission: 'permissionsModule', name: localizationConstants.permissions, url: '/roles/permissions' }
		]
	},
	{
		name: localizationConstants.phoenixAdmin,
		route: 'phoenix',
		displayName: localizationConstants.phoenixAdminTitle,
		children: [
			{ permission: 'phoenixCompanyList', name: localizationConstants.companyList, url: '/phoenix/company/list' },
			{ permission: 'phoenixModuleList', name: localizationConstants.module, url: '/phoenix/module/list' },
			{ permission: 'phoenixPackageList', name: localizationConstants.package, url: '/phoenix/package/list' },
			{ permission: 'phoenixApiKeyList', name: localizationConstants.apiKeyList, url: '/phoenix/api-key/list' }
		]
	},
	{
		name: localizationConstants.jumpbirdAdmin,
		route: 'jumpbird',
		displayName: localizationConstants.jumpbirdAdminTitle,
		children: [
			{ permission: 'jumpbirdCompaniesList', name: localizationConstants.companies, url: '/jumpbird/company/list' },
			{ permission: 'jumpbirdSubscriptionsListPackages', name: localizationConstants.packages, url: '/jumpbird/package/list' }
		]
	},
	{
		name: localizationConstants.resigoAdmin,
		route: 'resigo',
		displayName: localizationConstants.resigoAdminTitle,
		children: [
			{ permission: 'resigoAdminListMachines', name: localizationConstants.machineList, url: '/resigo/machine/list' },
			{ permission: 'resigoAdminListLicenses', name: localizationConstants.licenseList, url: '/resigo/licenses/list' }
		]
	},
	{
		name: localizationConstants.birdhubAdmin,
		route: 'birdhub',
		displayName: localizationConstants.birdhubAdminTitle,
		children: [
			{ permission: 'birdhubClientsList', name: localizationConstants.clients, url: '/birdhub/clients/list' }
		]
	},
	{
		name: localizationConstants.tse,
		route: 'tse',
		children: [
			{ permission: 'tseCustomerList', name: localizationConstants.dashboardTitle, url: '/tse/dashboard' },
			{ permission: 'tseDeviceList', name: localizationConstants.tseSerialUpload, url: '/tse/device/list' },
			{ permission: 'tseCustomerList', name: localizationConstants.universeCustomers, url: '/tse/universe/customer/list' },
			{ permission: 'tseCustomerListV2', name: localizationConstants.tseCustomers, url: '/tse/customer/list' }
		]
	},
	{
		name: localizationConstants.tools,
		route: 'tools',
		children: [
			{ permission: 'zmListGetRequests', name: localizationConstants.zmList, url: '/tools/zm/list' },
			{ name: 'Hobex', url: '/tools/hobex/list' }
		]
	}
];

class MenuService {
	generateSidebarMenu(profileResponse: UserProfileResponse): SideBarMenu[] {
		const sidebarMenu: SideBarMenu[] = [];
		const permissions = Object.keys(profileResponse.user.permissions);

		MENU_CONFIG.forEach(menuItem => {
			// Check if user has required permission for this menu section
			if (menuItem.requiredPermission && !permissions.includes(allPermissionMapping[menuItem.requiredPermission])) {
				return;
			}

			// Get all permissions for this menu section
			const allPermissions = filter(permissions, p => {
				return p.indexOf(`${menuItem.name}.`) === 0;
			}).map(permission => {
				return permission.split('.')[1];
			});

			// Generate children based on permissions
			const children = menuItem.children
				?.filter(child => !child.permission || permissions.includes(allPermissionMapping[child.permission]))
				.map(child => ({ name: child.name, url: child.url })) || [];

			// Skip menu items with no children (unless it's dashboard)
			if (children.length === 0 && menuItem.name !== localizationConstants.dashboardTitle) {
				return;
			}

			// Handle special case for roles/permissions
			if (menuItem.name === localizationConstants.role) {
				const roleModulePermission = permissions.includes(allPermissionMapping['rolesModule']);
				const permissionModulePermission = permissions.includes(allPermissionMapping['permissionsModule']);
				
				if (!roleModulePermission && !permissionModulePermission) {
					return;
				}

				if (!roleModulePermission) {
					children.splice(0, 1); // Remove roles
				}
				if (!permissionModulePermission) {
					children.splice(1, 1); // Remove permissions
				}
			}

			sidebarMenu.push({
				name: menuItem.displayName || menuItem.name,
				permissionName: menuItem.name,
				reactRoute: `/${menuItem.route}`,
				permissions: allPermissions,
				children: children
			});
		});

		return sidebarMenu;
	}
}

export default new MenuService(); 